import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import DataTableTdCheckbox from '@/components/datatable/DataTableTdCheckbox.vue';
import type { Log } from '@/types';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export function createLogFilterColumns(tableLabel: string): ColumnDef<Log>[] {
    return [
        {
            accessorKey: 'select',
            header: '',
            cell: ({ row }) => h(DataTableTdCheckbox, { row: row as any }),
            size: 24,
        },
        {
            accessorKey: 'name',
            header: ({ column }) =>
                h(DataTableColumnHeader, {
                    column: column,
                    title: tableLabel,
                }),
        },
        {
            accessorKey: 'count',
            header: ({ column }) =>
                h(DataTableColumnHeader, {
                    column: column,
                    title: 'activities.count',
                }),
        },
    ];
}
